import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { TestStatus } from 'enums';

interface ITestItemProps {
    description: string,
    id: number,
    // For styling. Unfortunately can't detect this with css because the groups and items are at the same html level.
    lastItemInGroup: boolean,
    name: string,
    resultMessage: string,
    selected: boolean,
    status: TestStatus,
}

export const TestItem: FunctionComponent<ITestItemProps> = ({ description, id, lastItemInGroup, name, resultMessage, selected, status }) => {
    const {t, i18n} = useTranslation();
    const [showingDescription, setShowingDescription] = useState(false);

    const toggleDescription = () => {
        setShowingDescription(!showingDescription);
    }

    return (<>
        <li
            className={cn({
                tests_item: true,
                tests_lastItemInGroup: lastItemInGroup,
                passed: status === TestStatus.Passed,
                failed: status === TestStatus.Failed,
                mixed: status === TestStatus.Canceled,
                running: status === TestStatus.InProgress,
            })}
        >
            <div className="tests_itemCols">
                <div className="tests_itemColName ellipsis">
                    {name}
                </div>
                <div className={cn({
                    tests_itemStatus: true,
                    passed: status === TestStatus.Passed,
                    failed: status === TestStatus.Failed,
                    canceled: status === TestStatus.Canceled,
                })}>
                    {status === TestStatus.Passed && (<>
                        <FontAwesomeIcon icon="check" className="tests_statusIcon passed" />
                        {t('tests.itemStatuses.passed')}
                    </>)}
                    {status === TestStatus.Failed && (<>
                        <FontAwesomeIcon icon="exclamation-triangle" className="tests_statusIcon failed" />
                        {t('tests.itemStatuses.failed')}
                    </>)}
                    {status === TestStatus.Canceled && (<>
                        <FontAwesomeIcon icon="exclamation-triangle" className="tests_statusIcon canceled" />
                        {t('tests.itemStatuses.canceled')}
                    </>)}
                    {status === TestStatus.Queued && (<>
                        {t('tests.itemStatuses.queued')}
                    </>)}
                </div>
                <div className="tests_itemColInfo" onClick={toggleDescription}>
                    <button onClick={toggleDescription} type="button" className="tests_itemInfoButton">
                        <FontAwesomeIcon icon="info-circle" className="tests_infoIcon" />
                    </button>
                </div>
            </div>
            {showingDescription && (
                <div className="tests_itemDescription">
                    {description}
                </div>
            )}
            {status === TestStatus.Failed && (
                <div className="tests_failDetails">
                    {resultMessage}
                </div>
            )}
        </li>
    </>);
}